<template>
  <div class="master">
    <div class="fixed-top row top-nav">
      <b-navbar toggleable="sm" type="dark" variant="gray-950" class="col" style="padding-left: 35px;">
  <img src="../../static/image/logo_Getac.svg" style="height: 1.429rem;" alt="Getac Logo" />
        <span class="bg-white mx-3" style="width:2px; height: 1.786rem;"></span>
        <span v-if="prdEnv()" class="text-white system-name">ETO NRE System Ver {{$session.get('version')}}</span>
        <span v-else class="text-white system-name">ETO NRE System Ver {{$session.get('version')}} - {{$session.get('mode')}}</span>



        <b-navbar-nav class="ml-auto align-items-center mr-3">

          <b-nav-item-dropdown class="ml-auto align-items-center">
            <template #button-content>
              <img src="../../static/image/icon_user.svg" style="height: 3.28rem" alt="User Icon" />
              <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_name')}}</b-nav-text>
              <!--
                  <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_roles')}}</b-nav-text>
                  <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_functions')}}</b-nav-text>
            -->

            </template>
            <b-dropdown-item href="#" @click="signout">Log Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>

    <!--#region -- NAV for FTIE features ---->
    <div style="padding-top: 70px;">
      <b-nav tabs align="left" style="font-size: 18px;">
        <b-nav-item to="/home"
                    style="padding-top: 10px;">
          <img src="../../static/image/icon_home_#F77530.svg" style="width: 28px; padding-bottom: 2px;" alt="Home Icon" />
          Home
        </b-nav-item>
        <!--
      <b-nav-item disabled>Assign (Comming Soon)</b-nav-item>
      <b-nav-item disabled>Owner (Comming Soon)</b-nav-item>
  -->
        <!-- <b-nav-item>Report</b-nav-item>   -->
        <b-nav-item style="padding-top: 12px;" to="/ftie/ftie-dashboard" exact exact-active-class="active">List</b-nav-item>
        <b-nav-item style="padding-top: 12px;"
                    to="/ftie/ftie-page-dashboard"
                    exact exact-active-class="active">
          Page
        </b-nav-item>
        <!--<b-nav-item disabled>Tree</b-nav-item>
                        to="/ftie/15301/SL4DZFAFAD9X/2574/1990/fc.jan"
                  :to="{ path: '/ftie/15301/SL4DZFAFAD9X/2574/1990/fc.jan' }"
  -->
        <!--<b-nav-item disabled>Share</b-nav-item> -->
        <!--<b-nav-item>Custom Level</b-nav-item>-->

      </b-nav>
    </div>
    <!---#endregion NAV ---->

    <!--#region -- Modal ---->


    <div v-if="loginUser">
      <div class="p-4">
        <div v-if="!loginUser" class="position-absolute d-flex" style="left: 0;right: 0;top: 4.286rem;bottom: 0;">
          <div class="m-auto" style="min-width: 15rem">
            <div class="h3 text-danger">
              Missing data, please contact system administrator. Alice Lee: alice.cy.lee@getac.com.tw
            </div>
          </div>
        </div>

        <!--#region -- Router View
             :currencySign="currencySign"
             :createBy="createBy"
             @save="saveData"
             @submit="submitData"
             @approve="approveData"
             @cancelNre="projectCancelData"
             @substitute="showSubstituteModal"
  ---->
        <router-view v-else
                     ref="child"
                     :readOnly="readOnly"
                     :loginUser="loginUser"
                     :data="$data"
                     :serverEnv="serverEnv"
                     @reload="reload" />
        <!--#endregion -->

      </div>
    </div>
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'ftie-master-page',
    props: {
      stageKey: {
        type: String,
        default: ''
      },
      stageApiBase: {
        type: String,
        default: ''
      },
      stageApiName: {
        type: String,
        default: ''
      },
      currencyDisabled: {
        type: Boolean,
        default: true
      }
    },
    data: () => {
      return {
        currencyTmp: null,
        nreData: null,
        ftieData: null,
        tmpData: null,
        //currency: null,
        /*
        currencyOptions: [
          { value: "GUSA(USD)", text: "GUSA(USD)" },
          { value: "WW (USD)", text: "WW (USD)" },
          { value: "EU (GBP)", text: "EU (GBP)" },
          { value: "EU (EUR)", text: "EU (EUR)" },
          { value: "EU (AUD)", text: "EU (AUD)" },
          { value: "GML (CNY)", text: "GML (CNY)" },

        ],

        currencySigns: {
          "GUSA(USD)": '$',
          "WW (USD)": '$',
          "EU (GBP)": '£',
          "EU (EUR)": '€',
          "EU (AUD)": '$',
          "GML (CNY)": '¥'
        },
        */

        frontEndUrlToUse: null,
      };
    },
    created() {
      let self = this;

      let callback = () => {
        //self.loadProjectProposalFileSetting();


        if (!self.readOnly) {
          console.log("!self.readOnly!");
        }
        /*
        else if (self.stageNumber === '30') {
          self.loadHqSalesWatch();
        }
        else if (self.stageNumber === '40') {
          self.loadMailGroupSetting();
          self.loadSaHeadWatch()
        }
        */

        //endregion

        //#region 未儲存提示

        $(window).on('beforeunload', function () {
          if (!self.readOnly && JSON.stringify(self.nreData) !== JSON.stringify(self.tmpData)) {
            return "You have made changes on this page that you have not yet confirmed.\nIf you navigate away from this page you will lose your unsaved changes";
          }
        });

        //#endregion

      };

      self.reload(callback);

    },
    computed: {
      
      readOnly() {
        return false;
        //return _.get(this.nreData, 'action_disabled', true);
      },
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      serverEnv() {
        return _.get(this.$store, 'state.env', null);
      },

      /*
      createBy() {
        return _.get(this.nreData, 'owner', null);
      },
      */

      /*
       *      currencySign() {
        return this.currencySigns[this.currency];
      },
       * */
    },
    methods: {
      //#region -- Private --
      /*
       *
       includeStages(stages) {
        return _.includes(stages, this.stageNumber)
      },
       */

      //#endregion

      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      //#region -- Permission --
      checkLoggedIn() {
        let self = this;
        let result = true;
        if (_.trim(self.loginUser) === '') result = false;
        self.frontEndUrlToUse = this.$session.get('frontEndUrlToUse');
        //if (!_.get(self.nreData, 'permission', false)) result = false;
        //if (!result) self.$router.push("/");
        return result;
      },
      //#endregion

      signout() {

        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            window.location = this.$session.get('frontEndUrlToUse') + '/azure-login';
          })
      },


      //#region -- Page Init --
      //#endregion

      //#region -- Page Events --

      /**
       * 
       saveTmpData(nreData) {
        this.tmpData = JSON.parse(JSON.stringify(nreData));
      },
       */

      reload(callback, keyPath) {
        let self = this;
        let nreData = null;
        let ftie_id = encodeURIComponent(self.$route.params.ftie_id);
        //let nre_id = encodeURIComponent(self.$route.params.nre_id);
        let real_sku_no = encodeURIComponent(self.$route.params.real_sku_no);
        //let create_by = encodeURIComponent(self.$route.params.create_by);
        let baseUrl = _.trim(self.$root.baseUrl);

        //let queryString = `ftie_id=${ftie_id}&nre_id=${nre_id}&real_sku_no=${real_sku_no}&create_by=${create_by}`;
        //let url = `${baseUrl}/${self.stageApiBase}/${self.stageApiName}?${queryString}`;

        let params = {
          username: self.loginUser
        };

        eventHub.$emit('loading', true);

        if (self.checkLoggedIn() && _.isFunction(callback)) {
          eventHub.$emit('loading', false);
          callback();
        }
        /*
        eventHub.$emit('loading', true);

        self.$axios.get(url, { params })
          .then((res) => {
            nreData = res.data;
            nreData.page_object = JSON.parse(nreData.page_object);

            let ref_skus = _.get(nreData, 'page_object.ref_skus', [{ region: '' }]);
            if (ref_skus.length > 0 && _.first(ref_skus).region !== '') {
              self.currency = _.first(nreData.page_object.ref_skus).region;
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.checkStatusForReasonDetail();

            if (_.trim(keyPath) === '') {
              self.nreData = nreData;
            }
            else {
              if (self.stageApiName === 'espm-kickoff') {
                self.nreData = nreData;
              } else {
                let tmp = JSON.parse(JSON.stringify(self.nreData));
                _.set(tmp, keyPath, _.get(nreData, keyPath));
                self.nreData = tmp;
              }
            }
            self.saveTmpData(nreData);


            if (self.checkLoggedIn() && _.isFunction(callback)) {
              callback();
            }
          });
          */
        //#endregion

      },

      /**
       * 
       *
       *postNreData(action, comments) {
        let self = this;

        let rejectReason = action === 'reject' ? comments : null;
        let deferReason = action === 'deferred' ? comments : null;
        let returnReason = action === 'return' ? comments : null;
        let cancelReason = action === 'cancel' ? comments : null;

        let selected_quote_for_gro = [];
        if (self.includeStages('80')) {

          if (action === 'reject') {
            _.each(self.nreData.page_object.quote_items, item => { item.quote_to_gro = 'N'; });
          }

          selected_quote_for_gro = _.filter(self.nreData.page_object.quote_items, { quote_to_gro: 'T' })

          if (action === 'submit' || action === 'deferred') {
            _.each(_.filter(self.nreData.page_object.quote_items, { quote_to_gro: 'T' }), item => { item.quote_to_gro = 'Y'; });
          }

        }

        let requestData = {
          button: action,
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          nre_object: {
            ...self.nreData.page_object,
            deferred_reason: deferReason,
            reject_reason: rejectReason,
            return_reason: returnReason,
            cancel_reason: cancelReason
          },
          selected_quote_for_gro: selected_quote_for_gro
        };

        let url = `${self.$root.baseUrl}/${self.stageApiBase}/${self.stageApiName}/`;

        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData)
          .then(res => {
            if (_.get(res, 'data.save_success', false)) {
              if (action === 'return') {
                let nre_id = requestData.nre_object.basic_info_review.nre_id;
                self.tmpData = self.nreData;// avoid show confirm modal when data change
                console.log(`action === 'return', nre_id = ${nre_id}`);
                let dashboard_url = `${self.$root.frontEndUrl}/dashboard/${nre_id}`;
                window.location.href = dashboard_url;
              } else {
                self.reload();
              }

            }

            eventHub.$emit('loading', false);
          });
      },
      saveData() {
        this.postNreData('save');
      },
      submitData() {
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('submit');
        }
        let options = {
          title: 'Submit',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Submit',
          cancelTitle: null
        };
        self.$root.msgBoxConfirm(`Are you sure want to submit?`, callback, options);
      },
       * 
       */
      

      //#endregion
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FtieMasterPage.vue